module.exports = __webpack_public_path__ + "img/category-popular-hover.b5854a58.png";